

require('xo-ui-components/src/directionality/directive');

define(['jquery', 'squid/index', 'text!./template.html'], function ($, squid, template) {

    squid.module('xo-dob-input.directive', ['squid']).directive('dobValidation', function () {

        return {
            require: 'ngModel',
            link: function link(scope, element, attr, ctrl) {

                // init scope vars
                // age - above 18 yrs
                // validDate - months <= 12 and day <= 31 or based on month
                scope.isValidDate = true;
                scope.isValidAge = true;
                scope.isValid = false;
                scope.dobToolTip = 'hide';

                function isValidDate(year, month, day) {
                    // dates like 02/31 33/33 should return false
                    var date = new Date(year, month, day);

                    var fullYear = date.getFullYear();
                    var dateMonth = date.getMonth();
                    var dateDay = date.getDate();

                    // If birth year is in the future or before 1900, dob is invalid
                    var now = new Date();
                    if (fullYear > now.getFullYear() || fullYear < 1900) {
                        return false;
                    }

                    if (fullYear === parseInt(year, 10) && dateMonth === parseInt(month, 10) && dateDay === parseInt(day, 10)) {
                        return true;
                    }
                    return false;
                }

                function isOfLegalAge(birthDate) {
                    // user should be of exact 18 years of age or older
                    var tempDate = new Date(birthDate.getFullYear() + 18, birthDate.getMonth(), birthDate.getDate());
                    return tempDate <= new Date().setHours(0, 0, 0, 0);
                }

                /**
                 * Parses input value to set corresponding day, month, year values for scope
                 * @param {String} inputVal - the value to be parsed
                 */
                function parseDob(inputVal) {
                    var day;
                    var month;
                    var year;

                    var sep = scope.dateSeparator();
                    var partsArr = inputVal.split(sep);
                    var first = partsArr[0];
                    var sec = partsArr[1];
                    var third = partsArr[2];

                    if (scope.dateFormat() === 'DMY') {
                        day = first;
                        month = sec;
                        year = third;
                    } else if (scope.dateFormat() === 'YMD') {
                        year = first;
                        month = sec;
                        day = third;
                    } else {
                        month = first;
                        day = sec;
                        year = third;
                    }

                    // Validate only on entering the last digit of the dob
                    var dayLen = ('' + day).length;
                    var monLen = ('' + month).length;
                    var yrLen = ('' + year).length;
                    var validDay = dayLen === 1 || dayLen === 2;
                    var validMon = monLen === 1 || monLen === 2;
                    var validYr = yrLen === 4;
                    var requirement = validDay && validMon && validYr;

                    if (requirement) {
                        scope.isValidDate = isValidDate(year, month - 1, day);

                        scope.isValidAge = isOfLegalAge(new Date(year, month - 1, day));
                        scope.isValid = scope.isValidDate && scope.isValidAge;
                        scope.dobToolTip = scope.isValid ? 'hide' : 'show';

                        scope.user.dob_day = day;
                        scope.user.dob_month = month;
                        scope.user.dob_year = year;
                    } else {
                        scope.isValid = false;
                    }

                    ctrl.$setValidity('dobText', scope.isValid);

                    return inputVal;
                }

                /**
                 * Validates the inputted DOB value
                 * @param {string} ngModelValue - the to-be mutated input value
                 * onComplete for mask listener - called when user copy/pastes DOB into the field
                 */
                scope.dobValidator = function dobValidator(ngModelValue) {
                    var input = element;
                    var dateMask = scope.dateMask();
                    input.mask(dateMask, {
                        translation: {
                            'Z': {
                                pattern: /[0-9]/, optional: true
                            },
                            '0': {
                                pattern: /[0-9]/, optional: false
                            }
                        },
                        onComplete: function onComplete(val) {
                            ngModelValue = val;
                            return parseDob(ngModelValue);
                        }
                    });

                    return parseDob(ngModelValue);
                };

                scope.dobTester = function dobTester(val) {
                    return parseDob(val);
                };

                ctrl.$parsers.push(scope.dobValidator);
            }
        };
    }).directive('xoDobInput', function () {
        return {
            template: template,
            restrict: 'E',
            scope: {
                user: '='
            },
            controller: function controller($scope, $locale) {

                // To support additional date separators, simply add separator to getDateSeparators function
                var DateManager = {
                    dateSeparator: undefined,
                    dateFormat: undefined,
                    griffinDateEntry: undefined,

                    _init_: function _init_() {
                        this.griffinDateEntry = $locale.metadata.dateEntry;
                        this.dateSeparator = this.getDateSeparator(this.griffinDateEntry);
                        this.dateFormat = undefined;
                        this.dateFormat = this.getDateFormat();
                        this.dateRegex = this.getDateRegex();
                        // dob validator depends on dateFormat function in $scope, so context is bound.
                        $scope.dateFormat = this.getDateFormat.bind(this);
                        $scope.dateSeparator = this.getDateSeparator.bind(this, this.griffinDateEntry);
                        $scope.dateMask = this.getDateMask.bind(this, this.dateSeparator);
                    },
                    getDateFormat: function getDateFormat() {
                        // cache date format value, must be unset on init
                        if (this.dateFormat) {
                            return this.dateFormat;
                        }

                        var griffinDateFormat = $locale.metadata.dateFormat.toUpperCase();
                        var dateFormatComponents = griffinDateFormat.split(this.dateSeparator);

                        var dIdx = dateFormatComponents.indexOf('DD'),
                            mIdx = dateFormatComponents.indexOf('MM');

                        var formatComponentMap = this.getFormatComponentIdxMappings();
                        if (formatComponentMap['DMY'].day === dIdx && formatComponentMap['DMY'].month === mIdx) {
                            return 'DMY';
                        } else if (formatComponentMap['MDY'].day === dIdx && formatComponentMap['MDY'].month === mIdx) {
                            return 'MDY';
                        }
                        return 'YMD';
                    },
                    setDobTextPlaceHolder: function setDobTextPlaceHolder() {
                        $scope.dobTextPlaceholder = this.griffinDateEntry.toUpperCase();
                    },
                    dobTextKeyupHandler: function dobTextKeyupHandler(event) {
                        this.updateDobBindings(true);
                    },
                    /**
                     * Absolutely makes sure that dob input doesn't contain bad characters.
                     * Called on any chatacter input AND on locale change.
                     */
                    updateDobBindings: function updateDobBindings(change) {
                        var cleanedDob = ($scope.dob.value || '').replace(this.dateRegex, '');
                        $scope.dob.value = cleanedDob;

                        // This way, our dob value is always formatted correctly.
                        if (change) {
                            $scope.dob.value = $('#dobText').val();
                        }
                    },
                    // Dynamically construct regex to only include date separator supported by country and nondigits
                    getDateRegex: function getDateRegex() {
                        var escapedRegexChars = ['.', '$', '^', '{', '[', '(', '|', ')', '*', '+', '?', '\\'];
                        var sep = this.dateSeparator;
                        var assembledRegex = '[^0-9' + (escapedRegexChars.indexOf(sep) !== -1 ? '\\' + sep : sep) + ']';
                        return new RegExp(assembledRegex, 'gi');
                    },
                    getDateMask: function getDateMask(dateSeparator) {
                        var dateFormat = this.dateFormat;
                        if (dateFormat === 'DMY' || dateFormat === 'MDY') {
                            return '0Z' + dateSeparator + '0Z' + dateSeparator + '0000';
                        }

                        return '0000' + dateSeparator + '0Z' + dateSeparator + '0Z';
                    },
                    getDateSeparator: function getDateSeparator(dateEntry) {
                        var ret = '';
                        this.getDateSeparators().forEach(function (ele, iter) {
                            // eslint-disable-line
                            if (dateEntry.indexOf(ele) !== -1) {
                                ret = ele;
                            }
                        });
                        return ret;
                    },
                    // To add any additional date separators, simply add them to the returned array.
                    getDateSeparators: function getDateSeparators() {
                        return ['-', '.', '/'];
                    },
                    // Handles changes in date component order or date separator change.
                    updateDateInputForFormat: function updateDateInputForFormat(oldFormat, newFormat, oldSeparator) {
                        var curDateVal = $scope.dob.value || '';

                        // Clear dob input if date is incomplete so user can see updated placeholder
                        if (curDateVal.length < 8) {
                            $scope.dob.value = '';
                            return;
                        }

                        var formatComponentIdxMappings = this.getFormatComponentIdxMappings(),
                            oldFormatIdxMapping = formatComponentIdxMappings[oldFormat],
                            newFormatIdxMapping = formatComponentIdxMappings[newFormat];
                        var oldDateComponents = curDateVal.split(oldSeparator),
                            newDateComponents = ['', '', ''];

                        newDateComponents[newFormatIdxMapping.day] = oldDateComponents[oldFormatIdxMapping.day];
                        newDateComponents[newFormatIdxMapping.month] = oldDateComponents[oldFormatIdxMapping.month];
                        newDateComponents[newFormatIdxMapping.year] = oldDateComponents[oldFormatIdxMapping.year];
                        $scope.dob.value = newDateComponents.join(this.dateSeparator);
                    },
                    getFormatComponentIdxMappings: function getFormatComponentIdxMappings() {
                        return {
                            'DMY': {
                                'day': 0,
                                'month': 1,
                                'year': 2
                            },
                            'MDY': {
                                'day': 1,
                                'month': 0,
                                'year': 2
                            },
                            'YMD': {
                                'day': 2,
                                'month': 1,
                                'year': 0
                            }
                        };
                    },
                    prefillFetchedDob: function prefillFetchedDob() {
                        if ($scope.user && $scope.user.dob_day && $scope.user.dob_month && $scope.user.dob_year) {
                            if (!$scope.dob) {
                                $scope.dob = {};
                            }

                            if (this.dateFormat === 'DMY') {
                                $scope.dob.value = $scope.user.dob_day + this.dateSeparator + $scope.user.dob_month + this.dateSeparator + $scope.user.dob_year;
                            } else if (this.dateFormat === 'YMD') {
                                $scope.dob.value = $scope.user.dob_year + this.dateSeparator + $scope.user.dob_month + this.dateSeparator + $scope.user.dob_day;
                            } else {
                                $scope.dob.value = $scope.user.dob_month + this.dateSeparator + $scope.user.dob_day + this.dateSeparator + $scope.user.dob_year;
                            }
                        } else {
                            $scope.dob = {
                                value: ''
                            };
                        }
                    }
                };

                DateManager._init_();
                DateManager.setDobTextPlaceHolder();
                DateManager.prefillFetchedDob();

                $scope.onDobTextKeyup = function (event) {
                    DateManager.dobTextKeyupHandler(event);
                };

                $scope.$on('localeChange', function () {
                    var oldDateFormat = DateManager.dateFormat;
                    var oldSeparator = DateManager.dateSeparator;
                    DateManager._init_();
                    DateManager.updateDateInputForFormat(oldDateFormat, DateManager.dateFormat, oldSeparator);
                    DateManager.updateDobBindings(false);
                    DateManager.setDobTextPlaceHolder();
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-form-components/src/dob-input/directive.js
// module id = ./components/xo-form-components/src/dob-input/directive.js
// module chunks = 1